<div *ngIf="!openSmall && !dialer.openSummaryModal"
    class="overlay dial-overlay position-fixed vh-100 vw-100 d-flex align-items-center justify-content-center">
    <div class="bg-white radius-16 dial-card">
        <div class="dial-main">
            <div class="border-bottom-0 py-4 px-3 d-flex flex-column justify-content-between align-items-start">
                <div class="d-flex align-items-center justify-content-between w-100 pb-4">
                    <p class="m-0 fs-16 fw-600" style="color: rgba(43, 48, 56, 1)">
                        Outgoing Call
                    </p>
                    <p class="m-0" (click)="ToggleMinimize()">
                        <img style="height: 26px" style="height: 30px; cursor: pointer"
                            src="./assets/images/icons/arrow-minimize.png" alt="" />
                    </p>
                </div>
            </div>
            <div class="dial-main-body">
                <p *ngIf="!showKeypad" class="fs-14 fw-500 m-0 w-100 text-center pb-4" style="color: rgba(137, 140, 144, 1)">
                    My Caller ID :
                    <span style="color: rgba(0, 0, 0, 1)">{{ dialer.selectedNumber | phoneFormat }}</span>
                </p>
                <p class="fs-16 fw-500 w-100 text-center m-0 pb-3" style="color: rgba(66, 71, 77, 1)">
                    {{ dialer.patientName }}
                </p>
                <p class="fs-28 fw-700 w-100 text-center m-0" style="color: rgba(39, 45, 53, 1)">
                    {{ dialer.selectedRecipientNumber | phoneFormat }}
                </p>
                <!-- Call script step tracker (hidden, not destroyed, while the keypad is open so the step is kept) -->
                <app-call-script [hidden]="showKeypad" [patientName]="dialer.patientName"
                    [phoneNumber]="dialer.selectedRecipientNumber" [practiceName]="dialer.practice_name"
                    [treatmentAmount]="dialer.treatment_amount" [displayLogo]="dialer.display_logo"
                    [debtDuration]="dialer.debt_duration"></app-call-script>
                <p class="fs-16 fw-500 w-100 text-center m-0 pt-3" style="color: rgba(113, 117, 122, 1)">
                    {{ dialer.isCallConnected ? "Calling..." : "Ringing...." }}
                </p>
                <p *ngIf="dialer.isInCall && dialer.isReconnecting" class="fs-16 fw-500 w-100 text-center m-0 pt-2"
                    style="color: #FFB020;">Reconnecting…</p>
                <p *ngIf="dialer.isInCall && !dialer.isReconnecting && dialer.callQualityWarning"
                    class="fs-16 fw-500 w-100 text-center m-0 pt-2" style="color: #FFB020;">{{
                    dialer.callQualityWarning.includes('bytes-received') ? 'Not receiving audio…' : 'Poor connection'
                    }}</p>
                <div class="pt-3" *ngIf="!showKeypad">
                    <img class="w-100" src="./assets/images/png/waveform-blue.png" alt="" />
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center pt-3">
                    <h4 class="text-muted text-center mb-0" *ngIf="dialer.callDuration">
                        Duration: {{ dialer.callDuration }}
                    </h4>
                    <h4 class="text-center text-danger mb-0 pt-2" style="font-size: 16px; font-weight: 600"
                        *ngIf="dialer.callDisconnected">
                        Call Ended
                    </h4>
                </div>
                <!-- IVR keypad: each key plays a DTMF tone into the live call -->
                <div class="px-4 pt-3" *ngIf="showKeypad">
                    <div class="digits-display d-flex align-items-center justify-content-center mb-3">
                        <p class="m-0 fs-20 fw-600 text-truncate"
                            style="color: rgba(39, 45, 53, 1); letter-spacing: 3px;">{{ dialer.sentDigits }}</p>
                        <span *ngIf="dialer.sentDigits" class="digits-backspace cursor d-flex align-items-center"
                            style="color: rgba(113, 117, 122, 1);" (click)="dialer.backspaceDigit()">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                <path d="M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z" />
                                <line x1="18" y1="9" x2="12" y2="15" />
                                <line x1="12" y1="9" x2="18" y2="15" />
                            </svg>
                        </span>
                    </div>
                    <div class="keypad-grid">
                        <button type="button" class="keypad-key" *ngFor="let key of keypadKeys"
                            [disabled]="!dialer.canSendDigits()" (click)="dialer.sendDigit(key.digit)">
                            <span class="keypad-digit">{{ key.digit }}</span>
                            <span class="keypad-letters">{{ key.letters }}</span>
                        </button>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center pt-4 gap-4">
                    <div *ngIf="dialer.isInCall" class="d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3 rounded-circle cursor d-flex flex-column align-items-center justify-content-center"
                            [style]="showKeypad ? 'background-color: #DCE7FA; color: #2B3038;' : 'background-color: #F2F5F8; color: #2B3038;'"
                            (click)="toggleKeypad()">
                            <ng-container *ngTemplateOutlet="keypadIcon; context: { size: 24 }"></ng-container>
                        </div>
                        <p class="m-0">Keypad</p>
                    </div>
                    <div *ngIf="dialer.isInCall" class="d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3 rounded-circle d-flex flex-column align-items-center justify-content-center"
                            [style]="
                  dialer.isMuted
                    ? 'background-color: #FDE5E5;'
                    : 'background-color: #F2F5F8;'
                " (click)="dialer.toggleMute()">
                            <img class="hw-24" [src]="
                    dialer.isMuted
                      ? 'assets/images/icons/microphone-off.svg'
                      : 'assets/images/icons/microphone.png'
                  " alt="" />
                        </div>
                        <p class="m-0">Mute</p>
                    </div>
                    <div *ngIf="dialer.isInCall"
                        class="d-flex flex-column align-items-center justify-content-center">
                        <div class="p-3 rounded-circle cursor d-flex flex-column align-items-center justify-content-center"
                            style="background-color: rgba(235, 56, 56, 1)" (click)="callended()">
                            <img style="filter: invert(1)" class="end-call-icon" src="./assets/images/svg/phone.svg"
                                alt="" />
                        </div>
                        <p class="m-0">End Call</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="Calling-container" *ngIf="openSmall && !dialer.openSummaryModal">
    <div class="calling-body" *ngIf="!smaller">
        <div class="modal-dialog w-100 mx-0" style="border-radius: 16px;">
            <div class="border-0 rounded-4 border-radius" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); ">
                <div class="call-incomming text-white rounded-top-4 row border-radius"
                    style="background-color: #B6CBF3;box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-style: solid; border-color: #FFFFFF; border-width: 1px 1px 1px 2px;">
                    <div class="col-1 d-flex align-items-center" (click)="smaller = !smaller"
                        style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                        <img class="hw-20" src="assets/images/png/open-right.png" alt="">
                    </div>
                    <div class="col-11 py-3 px-4 border-radius"
                        style="background-color: #2B3038;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="m-0">{{dialer.patientName ? dialer.patientName : 'Guest User'}}<span
                                        *ngIf="dialer.subName"> ({{dialer.subName}})</span></h5>
                                <p class="m-0 pt-1">{{dialer.selectedRecipientNumber | phoneFormat}}</p>
                                <p *ngIf="!dialer.isInCall && !dialer.callDisconnected" class="fs-16 m-0" style="color: #71757A;">
                                    Ringing....</p>
                                <p *ngIf="dialer.isInCall" class="m-0">Duration: {{ dialer.callDuration }}</p>
                                <p *ngIf="dialer.isInCall && dialer.isReconnecting && !dialer.callDisconnected"
                                    class="m-0 fw-500" style="color: #FFB020;">Reconnecting…</p>
                                <p *ngIf="dialer.isInCall && !dialer.isReconnecting && dialer.callQualityWarning && !dialer.callDisconnected"
                                    class="m-0 fw-500" style="color: #FFB020;">{{ dialer.callQualityWarning.includes('bytes-received') ? 'Not receiving audio…' : 'Poor connection' }}</p>
                                <p *ngIf="dialer.callDisconnected" class="m-0 text-danger fw-500 ">Call Ended</p>
                            </div>
                            <div class="d-flex flex-column align-items-end gap-2">
                                <div>
                                    <p class="m-0" (click)="ToggleMaximize()">
                                        <img style="height: 24px;cursor: pointer;"
                                            src="./assets/images/icons/arrows-diagonal.png" alt="">
                                    </p>
                                </div>
                                <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div *ngIf="dialer.isInCall"
                                        class="hw-38 p-2 cursor rounded-circle d-flex align-items-center justify-content-center"
                                        style="background-color: #F2F5F8; color: #2B3038;" (click)="openKeypad()">
                                        <ng-container *ngTemplateOutlet="keypadIcon; context: { size: 18 }"></ng-container>
                                    </div>
                                    <img *ngIf="dialer.isInCall" class="hw-38 p-2 cursor rounded-circle"
                                        [style]="dialer.isMuted == true ? 'background-color: #FDE5E5;' : 'background-color: #F2F5F8;'"
                                        [src]="dialer.isMuted == true ? 'assets/images/icons/microphone-off.svg' : 'assets/images/icons/microphone.png'"
                                        alt="mute" (click)="dialer.toggleMute()" />
                                    <img *ngIf="dialer.isInCall" class="hw-38 p-2 cursor rounded-circle"
                                        style="background-color: rgba(235, 56, 56, 1);"
                                        src="assets/images/svg/phone.svg" alt="Close" (click)="dialer.Callended()" />
                                    <img *ngIf="dialer.showIcomming && !dialer.callDisconnected && !dialer.isInCall"
                                        class="hw-38 p-2 cursor rounded-circle"
                                        style="background-color: rgba(235, 56, 56, 1);"
                                        src="assets/images/svg/phone.svg" alt="Close" (click)="callended()" />
                                    <img *ngIf="dialer.callDisconnected" class="hw-38 p-2 cursor rounded-circle"
                                        style="background-color: #F2F5F8; opacity: 50%;"
                                        src="assets/images/icons/microphone-off.svg" alt="mute" />
                                    <img *ngIf="dialer.callDisconnected" class="hw-38 p-2 cursor rounded-circle"
                                        style="background-color: rgba(235, 56, 56, 1); opacity: 50%;"
                                        src="assets/images/svg/phone.svg" alt="Close" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="smaller-modal" *ngIf="smaller">
        <div *ngIf="smaller" class="modal-dialog w-100 mx-0">
            <div class="border-0 rounded-4 border-radius" style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); ">
                                <div class="call-incomming text-white rounded-top-4 row border-radius"
                    style="background-color: #B6CBF3;box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-style: solid; border-color: #FFFFFF; border-width: 1px 1px 1px 2px;">
                   <div class="col-3 p-0">

                       <div class="h-100 px-1 w-100 d-flex align-items-center" (click)="smaller = !smaller"
                           style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                           <img class="hw-20 icon-active" src="assets/images/png/open-right.png" alt="">
                       </div>
                   </div>
                    <div class="col-9 p-0">
                        <div class="py-3 px-4 border-radius" style="background-color: #2B3038;">
                            <h5 class="m-0 text-center py-3">{{patient_name_innitials ? patient_name_innitials : "GU"}}</h5>
                            <img class="hw-27 mt-1 cursor rounded-circle"
                                src="assets/images/icons/phone.png"
                                alt="Close" (click)="callended()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="dialer.openSummaryModal" class="overlay dial-overlay position-fixed vh-100 vw-100 d-flex align-items-center justify-content-center" 
     style="background: rgba(0,0,0,0.4); top: 0; left: 0;">
  
  <div style="width:402px; max-width:92vw; max-height:90vh; background:#fff; border-radius:16px; box-shadow:0 20px 50px rgba(0,0,0,.2); overflow-y:auto; padding:24px; font-family: 'Inter', sans-serif;">

    <div style="font-weight:600; font-size:16px; margin-bottom:26px; color: #2b3038;">
      Call Summary
    </div>

    <div style="display: flex; align-items: center; gap: 12px;">
  <div style="
    width: 44px; 
    height: 44px; 
    background-color: #F4FAFD; 
    border-radius: 50%; 
    display: flex; 
    align-items: center; 
    justify-content: center;
    flex-shrink: 0;
  ">
    <img src="assets/images/icons/arrow-down-right-blue.png" style="width: 20px; height: 20px;" alt="Outgoing">
  </div>

  <div style="display: flex; flex-direction: column; justify-content: center;gap: 3px">
    <div style="color: #217ca6; font-size: 14px; font-weight: 500; line-height: 1.2;">
      Outgoing Call
    </div>
    <div style="font-size: 16px; font-weight: 700; color: #2b3038; margin-top: 2px; letter-spacing: -0.01em;">
      {{dialer.selectedRecipientNumber | phoneFormat }} 
    </div>
  </div>
</div>

    <label style="font-size:14px; font-weight:600; display:block; color: #0D1321; margin-bottom: 8px; margin-top: 20px;line-height: 1.5;">
      Status
    </label>
    <div style="position: relative; margin-bottom: 20px;">
      <div (click)="toggleStatus()" 
           style="width:100%; height:44px; border:1px solid #d0d1d3; border-radius:6px; padding:0 16px; display:flex; align-items:center; justify-content:space-between; cursor:pointer; background:#fff;">
        <div style="display:flex; align-items:center; gap:10px;text-transform: uppercase;">
          <img *ngIf="status === 'pending'" src="assets/images/icons/pendingicon.svg" style="width:20px;">
          <img *ngIf="status === 'verified'" src="assets/images/svg/checktick.svg" style="width:20px;">
          <img *ngIf="status === 'not_verified'" src="assets/images/icons/cross-circle.png" style="width:20px;">
          <span style="font-size:14px; font-weight:500; color:#5A5E64">
            {{ status.replace('_', ' ') }}
          </span>
        </div>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0D1321" stroke-width="2.5" 
             [style.transform]="isStatusOpen ? 'rotate(180deg)' : 'rotate(0deg)'" style="transition: 0.2s;">
          <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

    <div *ngIf="isStatusOpen"
        style="position:absolute; top:50px; left:0; width:100%; background:#fff; border-radius:16px; box-shadow:0 10px 30px rgba(0,0,0,0.1); border:1px solid #d0d1d3; z-index:100; overflow:hidden;">
        <div *ngFor="let opt of statusOptions"
     (click)="selectStatus(opt.value)"
     [style.pointer-events]="initialStatus !== 'pending' && opt.value === 'pending' ? 'none' : 'auto'"
     [style.opacity]="initialStatus !== 'pending' && opt.value === 'pending' ? '0.5' : '1'"
     style="padding:12px 16px; display:flex; align-items:center; gap:10px; cursor:pointer; border-bottom: 1px solid #f8fafc;">
            <img [src]="opt.icon" style="width:20px;">
            <span style="font-size:14px; font-weight:500;color: #5A5E64;">{{ opt.label }}</span>
        </div>
    </div>
    </div>

    <ng-container *ngIf="!isContactPersonRelation">
    <label style="font-size:14px; font-weight:600; display:block; color: #0D1321; margin-bottom: 8px;">
      Relation Tag
    </label>
    <div style="position: relative; margin-bottom: 20px;">
      <div (click)="toggleRelation()" 
           style="width:100%; height:44px; border:1px solid #d0d1d3; border-radius:6px; padding:0 16px; display:flex; align-items:center; justify-content:space-between; cursor:pointer; background:#fff;">
        <span style="font-size:14px; font-weight:500; color:#5A5E64;">{{ relationTag }}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0D1321" stroke-width="2.5" 
             [style.transform]="isRelationOpen ? 'rotate(180deg)' : 'rotate(0deg)'" style="transition: 0.2s;">
          <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

    <div *ngIf="isRelationOpen"
     style="position:absolute; top:50px; left:0; width:100%; background:#fff; border-radius:12px; box-shadow:0 10px 30px rgba(0,0,0,0.1); border:1px solid #E3E6EA; z-index:100; overflow:hidden;">

  <div *ngFor="let relation of relations; let i = index"
       (click)="selectRelation(relation)"
       style="padding:12px 16px; cursor:pointer; font-size:14px; font-weight: 500; border-bottom: 1px solid #f8fafc; color: #5A5E64;"
       
       [style.backgroundColor]="relation === relationTag ? '#f1f5f9' : '#fff'"
       [style.fontWeight]="relation === relationTag ? '600' : '500'"

       onmouseover="this.style.backgroundColor='#f9fafb'"
       onmouseout="this.style.backgroundColor='#fff'">

    {{ relation }}

  </div>

</div>
    </div>
    </ng-container>

<div *ngIf="this.status !== 'not_verified' && this.status !== 'dnd' && this.status !== 'pending' && this.dialer.verificationStatus !== 1" 
  (click)="$event.stopPropagation()"
  style="margin-top:20px; display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none;"
>
  <div 
    (click)="isDefault = !isDefault; $event.stopPropagation()"
    [style.background-color]="isDefault ? '#279f63' : '#fff'"
    [style.border-color]="isDefault ? '#279f63' : '#E3E6EA'"
    style="
      width: 20px; 
      height: 20px; 
      border: 2px solid; 
      border-radius: 4px; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      transition: all 0.2s;
    "
  >
    <svg 
      *ngIf="isDefault"
      width="12" 
      height="12" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="#fff" 
      stroke-width="4" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  </div>

  <span 
    (click)="isDefault = !isDefault; $event.stopPropagation()"
    style="font-size: 14px;"
  >
    Mark this as default contact
  </span>

</div>
   <div class="me-2 mt-3" *ngIf="this.status !== 'not_verified' && this.status !== 'dnd' && this.status !== 'pending' && !eConsent_value && dialer.debt_type != 2">
  <input tappable  [ngClass]="{'hex-65-grey': eConsent}"  class="secondary-checkbox" type="checkbox" name="filter" [(ngModel)]="eConsent"id="3" [disabled]="eConsent_value">
  <label tappable class="fs-14 fw-400 m-0" for="3">
    E-consent
  </label>
</div>
    <label style="font-size:14px; font-weight:600; margin-top:24px; display:block; color: #0D1321;">
      Add Notes <span style="color: #ff0000;">*</span>
    </label>
    <textarea
      [(ngModel)]="notes"
      placeholder="Type something..."
      style="width:100%; height:116px; border:1px solid #d0d1d3; border-radius:12px; padding:12px; resize:none; margin-top:8px; outline: none; font-size: 14px;"
      class="hide-scroll"
    ></textarea>

    <button
      (click)="saveDetails()"
      [disabled]="!notes || notes.trim().length === 0"
      [style.background]="notes && notes.trim().length ? '#279f63' : '#E5E7EB'"
      [style.color]="notes && notes.trim().length ? '#fff' : '#9ca3af'"
      style="width:100%; height:48px; margin-top:24px; border-radius:12px; border:none; font-weight:700; font-size: 15px; cursor: pointer; transition: 0.3s;"
    >
      Add Note & Save Details
    </button>

  </div>
</div>

<!-- 9-dot dial pad glyph, inherits the colour of the button it sits in -->
<ng-template #keypadIcon let-size="size">
    <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="5" cy="5" r="2" />
        <circle cx="12" cy="5" r="2" />
        <circle cx="19" cy="5" r="2" />
        <circle cx="5" cy="12" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="19" cy="12" r="2" />
        <circle cx="5" cy="19" r="2" />
        <circle cx="12" cy="19" r="2" />
        <circle cx="19" cy="19" r="2" />
    </svg>
</ng-template>
